<div>
  @if (isLarge) {
    <div class="buttons-container">
      @for (button of buttons; track button) {
        @if (button) {
          <lib-utmc-button
            [color]="button.color"
            (onClick)="button.onClick()"
            [class]="'action-button ' + (button.class || '')"
            [disabled]="button.disabled && button.disabled()"
            [hidden]="button.hidden && button.hidden()"
            [triggerId]="button.id"
            [loading]="button.loading"
            [title]="button.title"
            matomoTrigger
            >
            @if (!button.loading) {
              @if (button.icon) {
                <i class="material-icons">{{ button.icon }}</i>
              }
              @if (button.titlecase === false) {
                <span class="button-label">{{ button.label }}</span>
              } @else {
                <span class="button-label">{{ button.label }}</span>
              }
            }
          </lib-utmc-button>
        }
      }
    </div>
  }
  @if (!isLarge) {
    <div class="minimized">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <i class="material-icons">more_vert</i>
      </button>
      <mat-menu #menu="matMenu">
        @for (button of buttons; track button) {
          @if (button) {
            <div
              mat-menu-item
              class="button-item"
              style="display: flex; align-items: center; justify-content: center"
              >
              <lib-utmc-button
                [color]="button.color"
                (onClick)="button.onClick()"
                [class]="'action-button'"
                [disabled]="button.disabled && button.disabled()"
                [hidden]="button.hidden && button.hidden()"
                [triggerId]="button.id"
                matomoTrigger
                >@if (button.icon) {
                <i class="material-icons">{{ button.icon }}</i>
              }
              <span class="button-label">{{ button.label | titlecase }}</span></lib-utmc-button
              >
            </div>
          }
        }
      </mat-menu>
    </div>
  }
</div>
